<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <CDataTable
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                :items="items"
                :fields="fields"
                :items-per-page="small ? 50 : 20"
                :dark="dark"
                pagination
            >
              <template #index="{item,index}">
                <td> {{ index + 1 }}</td>
              </template>

              <template #avata="{item,index}">
                <td>
                  <div class="c-avatar">
                    <img :src="item.src" class="c-avatar-img" alt="">
                    <span
                        class="c-avatar-status"
                        :class="`bg-success`"
                    ></span>
                  </div>
                </td>
              </template>

              <template #members="{item,index}"  >
                <td  @click="toggleDetails(item, index)">
                  <p class="mb-0"> {{ item.code }}</p>
                  <p class="mb-0" style="white-space: nowrap;">{{ item.prefix }}. {{ item.firstName }}
                    {{ item.lastName }}</p>
                </td>
              </template>

              <template #attend="{item,index}">
                <td class="text-center"> {{ item.historys.length }} / {{ max }}</td>
              </template>


              <template #calss="{item,index}">
                <td>
                  <p class="mb-0"> <span class="font-weight-bold">Code : </span> {{ (item.historys.length >0)?item.historys[0].code:"" }} </p>
                  <p class="mb-0" style="white-space: nowrap;"> <span class="font-weight-bold">Title : </span>{{  (item.historys.length >0)?item.historys[0].title:"" }}</p>
                </td>
              </template>

              <template #dateTime="{item,index}">
                <td>
                  <p class="mb-0 text-right"> <span class="font-weight-bold">IN :</span> {{ new moment().format("DD/MM/YYYY HH:mm") }}</p>
                  <p class="mb-0 text-right"> <span class="font-weight-bold">OUT :</span> {{  new moment().format("DD/MM/YYYY HH:mm") }}</p>
                </td>
              </template>

              <template #action="{item}">
                <td style="width: 140px">
                  <CRow>
                    <CCol class="text-center">
                      <CButton class="mr-1" v-c-tooltip.hover.click="'Studens'" size="sm" color="success" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >
                        <CIcon name="cil-people"/>
                      </CButton>

                    </CCol>
                  </CRow>
                </td>
              </template>



              <template #details="{item}">
                <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
                  <CCardBody>
                    <CDataTable
                        table-filter
                        :items="item.historys"
                        items-per-page-select
                        :items-per-page="20"
                        hover
                        sorter
                        pagination
                    >

                    </CDataTable>
                  </CCardBody>
                </CCollapse>
              </template>


            </CDataTable>
          </CCol>
        </CRow>

      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'

export default {
  name: 'History',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"avata", label:"", _style: 'width:50px; text-align: center'},
          {key:"members", label:"Member",  _style: 'width:200px;'},
          {key:"calss", label:"Class Info",},
          {key:"dateTime", label:"Last Update",  _style: 'width:190px;'},
          // {key:"action", label: "#"}
          // {key:"attend", label:"Attend Class",  _style: 'width:200px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },

  data: function () {
    return {

      collapseDuration: 0,
      isDialog: false,
      method: [],
      max : 10,


      items: [{
        datetime:"10:00 - 11:00",
        location:"AS 202",
        code:"1001203",

      }]


    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    toggleDetails (item) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    }


  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
